import React from "react";
import { FormattedMessage } from "react-intl";

import "./summaryBar.css";

/*
    Overall summary for task counts
*/

const mapStateToProps = (state) => ({
    totalTasks: state.tasks.counts?.totalCount,
    unassignedTasks: state.tasks.counts?.unassignedTask,
    pastDueDateTaskCount: state.tasks.counts?.dueTasksCount,
    emergencyTasks: state.tasks.counts?.emergencyCount,
    priorityTasks: state.tasks.counts?.priorityCount,
    tasks: state.tasks.tasks,
    filter: state.tasklist.filter,
});

export const SummaryBar = (props) => {
    const { title, items, children } = props;

    // iterate through the items and display the value
    // and the caption under it
    // An free form elements can be added as child elements
    return (
        <div className="overall-summary-header">
            <div className="overall-summary-header-left">{title}</div>
            {items.map((item, index) => (
                <div className={"overall-summary-header-left " + item.className} role="total" key={index}>
                    <span className="value">{item.value}</span> <br />
                    <span className="subtitle">{item.caption}</span>
                </div>
            ))}

            {children}
        </div>
    );
};

export default SummaryBar;
